let isLoading = false;
let callbacks: any = [];


export function getYTObject(): Promise<any> {
  if ((<any>window).YT && (<any>window).YT.loaded) {
    return Promise.resolve((<any>window).YT);
  }
  return new Promise((resolve, reject) => {
    callbacks.push(resolve);
    if (isLoading) {
      return;
    }
    (<any>window).onYouTubeIframeAPIReady = () => {
      $.each(callbacks, (index, callback) => {
        callback((<any>window).YT);
      });
      delete (<any>window).onYouTubeIframeAPIReady;
    };

    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.youtube.com/iframe_api';
    document.body.appendChild(script);
    isLoading = true;
  });
}

export function setVideoRatioFromSlider($slider: JQuery) {
  const $firstImage = $slider.find('.js-variableSizeImage').first();
  if ($firstImage.length) {
    $firstImage.one('load', () => {
      const width = $firstImage.width() || 0;
      const height = $firstImage.height() || 0;
      if (width && height) {
        const ratioPercent = (height / width) * 100;
        $slider.find('.js-responsiveVideo').css('padding-bottom', ratioPercent + '%');
      }
    });
  }
}

export function setupNewYoutubePlayer($playerWrapper: JQuery) {
  getYTObject().then((YT) => {
    if ($playerWrapper && $playerWrapper.data('config') !== '') {
      let config = $playerWrapper.data('config');
      new YT.Player(config.youtubePlayerElementId, {
        videoId: config.videoId,
        host: 'https://www.youtube-nocookie.com',
        playerVars: {
          showinfo: 0,
          rel: 0,
          loop: config.isVideoLooping ? 1 : 0,
          playlist: config.isVideoLooping ? config.videoId : '',
          controls: 2,
        },
        events: {
          'onReady': (event) => {
            event.target.playVideo();
          },
        },
      });
    }
  });
}

export function removeYoutubePlayer($playerWrapper: JQuery) {
  let id = $playerWrapper.find('iframe').attr('id');
  $playerWrapper.empty().append('<div id="' + id + '"></div>');
}
